import Vue from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';
import VueCookies from 'vue-cookies';
import dayjs from '@/plugins/dayjs';

Vue.use(VueI18n);
Vue.use(VueCookies);

Vue.$cookies.config('4h', '', '', process.env.NODE_ENV === 'production', 'Strict');

function loadLocaleMessages(): LocaleMessages {
	const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
	const messages: LocaleMessages = {};
	locales.keys().forEach((key) => {
		const matched = key.match(/([A-Za-z0-9-_]+)\./i);
		if (matched && matched.length > 1) {
			const locale = matched[1];
			messages[locale] = locales(key);
		}
	});
	return messages;
}

function checkCurrentLanguage(): string | undefined {
	let currentLanguage: string | undefined = process.env.VUE_APP_I18N_LOCALE;
	if (Vue.$cookies.isKey('Language')) {
		currentLanguage = Vue.$cookies.get('Language').code;
	} else {
		Vue.$cookies.set('Language', { code: process.env.VUE_APP_I18N_LOCALE }, '3m');
	}
	if (currentLanguage === 'en') {
		currentLanguage = 'en-gb';
	}

	setDayjsLocale(currentLanguage || 'en-gb');

	return currentLanguage;
}

function setDayjsLocale(lang: string): void {
	switch (lang) {
		case 'en-gb':
			dayjs.locale('en-gb');
			break;
		case 'fr':
			dayjs.locale('fr');
			break;
		default:
			dayjs.locale('en-gb');
			break;
	}
}

export default new VueI18n({
	locale: checkCurrentLanguage() || 'en-gb',
	fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en-gb',
	messages: loadLocaleMessages(),
});
